import { render, staticRenderFns } from "./TaskIsolateButton.vue?vue&type=template&id=cc8fc4a2&scoped=true"
import script from "./TaskIsolateButton.vue?vue&type=script&lang=js"
export * from "./TaskIsolateButton.vue?vue&type=script&lang=js"
import style0 from "./TaskIsolateButton.vue?vue&type=style&index=0&id=cc8fc4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8fc4a2",
  null
  
)

export default component.exports